module.exports = __webpack_public_path__ + "img/p__中国医科大学.30c0fbdc.png";